module.exports = __webpack_public_path__ + "img/section24.d6fe00b7.png";